const AddPriceCSVUpload = () => {
  // TODO: adding pricing list in bulk using CSV is underdiscussion.
  // This flow will be added after confirmation
  return <div>AddPriceCSVUpload</div>;
};

export default AddPriceCSVUpload;
